export default function (configuration: any) {
    return {
        message: configuration.message,
        richTextMessage: configuration.richTextMessage,
    }
}
